import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getPathParams, methodGet, waitForSeconds } from "../helper";
import info from "../data/formulaires.json";

export default function Home({}) {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({});
  const [errorMessage, setErrorMessage] = useState(null);
  const [lien, setLien] = useState(null);
  /*
  {
    "id": "7",
    "date": "2023-04-25",
    "societe": "Test CCO",
    "code": "Ynpa6djkE6R4UO",
    "commentaire": "Test Drivers",
    "formType": "0"
  }
  */
  const [formInfo, setFormInfo] = useState(null);

  useEffect(() => {
    if (lien) return;
    let params = getPathParams();
    if (!params) {
      setLien("noLien");
    } else {
      methodGet("/getLink.php?linkCode=" + params.code).then((res) => {
        setLien(res[0]);
      });
    }
  }, []);

  useEffect(() => {
    if (lien && lien !== "noLien") {
      setFormInfo(info.forms[lien.formType]);
      setUserInfo({ ...userInfo, societe: lien.societe, formType: lien.formType });
      localStorage.setItem("lien", lien.code);
      showElements();
      setTimeout(() => {
        document.getElementById("form").classList.remove("opacity-0");
      }, 1800);
    }
  }, [lien]);

  async function showElements() {
    await waitForSeconds(0.2);
    document.getElementById("logo").classList.remove("ml-10");
    document.getElementById("logo").classList.remove("opacity-0");
    await waitForSeconds(0.3);
    document.getElementById("title").classList.remove("opacity-0");
    document.getElementById("title").classList.add("md:ml-10");
    await waitForSeconds(0.3);
    document.getElementById("subtitle").classList.remove("opacity-0");
    document.getElementById("subtitle").classList.add("md:ml-10");
  }

  async function onStart() {
    setErrorMessage(null);
    if (!userInfo.name) return setErrorMessage("S'il vous plaît entrez votre nom");
    if (!userInfo.societe) return setErrorMessage("Veuillez entrer le nom de votre entreprise");
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
    localStorage.removeItem("reponses");
    document.getElementById("main").classList.remove("space-y-20");
    document.getElementById("logo").classList.add("opacity-0");
    document.getElementById("title").classList.add("opacity-0");
    document.getElementById("subtitle").classList.add("opacity-0");
    document.getElementById("form").classList.add("opacity-0");
    document.getElementById("title").classList.remove("md:ml-10");
    document.getElementById("subtitle").classList.remove("md:ml-10");
    await waitForSeconds(0.25);
    navigate("/form/" + lien.formType + "#1");
  }

  return (
    <div id="main" className="flex flex-col max-w-6xl mx-auto mb-10 md:h-screen items-center justify-between py-8 md:py-20 p-4">
      {!formInfo && !lien && <p>Loading . . .</p>}
      {formInfo && (
        <div className="flex flex-col items-center md:items-start md:flex-row-reverse space-y-5 md:space-y-0">
          <img id="logo" src={formInfo.image} className="ml-10 md:w-3/5 opacity-0 transition-all duration-1000 ease-out" alt="logo" />
          <div className="flex flex-col text-center md:text-left md:space-y-2 md:w-3/5 items-center md:items-start transition-all duration-1000 ease-out">
            <h1 id="title" className="text-3xl md:text-4xl lg:text-5xl opacity-0 transition-all duration-700 ease-out">
              {formInfo.title}
            </h1>
            <p id="subtitle" className="text-lg font-semibold leading-snug md:text-2xl lg:text-3xl opacity-0 transition-all duration-700 ease-out">
              {formInfo.subtitle}
            </p>
          </div>
        </div>
      )}
      {!lien && <p className="">Votre lien n'est plus valide</p>}
      {lien === "noLien" && (
        <div className="flex flex-col items-center space-y-10">
          <div className="rounded-3xl bg-palette-green p-10">
            <img src="/images/logo.png" className="" width={"200px"} />
          </div>
          <h3 className="text-xl md:text-2xl lg:text-xl">Entrez via un lien partagé pour démarrer un questionnaire</h3>
        </div>
      )}
      {lien && formInfo && (
        <div
          id="form"
          className="flex my-10 border w-fit max-w-4xl justify-between border-palette-green rounded-xl p-5 md:p-10 flex-col md:flex-row opacity-0 transition-all duration-700 ease-out space-y-4 text-center"
        >
          <div className="md:w-2/4 text-left space-y-2">
            {formInfo.description.map((e) => (
              <p className="">{e}</p>
            ))}
          </div>
          <div className="flex flex-col space-y-4 md:items-end">
            <div className="flex flex-col items-start space-y-1">
              <p className="font-bold">Nom</p>
              <input
                onChange={(e) => setUserInfo({ ...userInfo, name: e.target.value })}
                value={userInfo.name}
                className="w-full bg-transparent text-md border border-palette-green text-gray-900 py-1 px-2 rounded-md"
              />
            </div>
            <div className="flex flex-col items-start space-y-1">
              <p className="font-bold">Société</p>
              <input
                onChange={(e) => setUserInfo({ ...userInfo, societe: e.target.value })}
                value={userInfo.societe}
                className="w-full bg-transparent text-md border border-palette-green text-gray-900 py-1 px-2 rounded-lg"
              />
            </div>
            <div className="flex flex-col items-center space-y-4 lg:space-x-4 lg:space-y-0 lg:flex-row">
              <button onClick={onStart} className="font-semibold border w-fit bg-palette-green text-white rounded-lg px-4 py-1.5">
                Commencer
              </button>
              {errorMessage && <p className="text-center font-semibold text-red-300">{errorMessage}</p>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
